import { ArtifactKind } from '@hangar/shared';
import { FormField, fieldA11y } from '@/components/FormField';
import { Input } from '@/components/ui/input';
import { OptionSelect } from '@/components/OptionSelect';
import { useSeesProviders } from '@/lib/useAudience';
import { buildConfigCopy } from './profileFormModel';
import type { ProfileFormApi } from './useProfileForm';

/** Expo / React Native only: the eas.json build profile, a file of the client's repository (native apps pick a workflow per environment instead). */
function EasProfileField({ form }: { form: ProfileFormApi }) {
  const error = form.errorFor('providerProfile', true);
  const copy = buildConfigCopy(useSeesProviders());
  return (
    <FormField id="profile-provider-profile" label={copy.label} hint={copy.hint} error={error}>
      <Input data-testid="profile-provider-profile" value={form.values.providerProfile} onChange={(e) => form.setProviderProfile(e.target.value)} placeholder="production" className="font-mono sm:text-[13px]" maxLength={64} spellCheck={false} {...fieldA11y('profile-provider-profile', error, copy.hint)} />
    </FormField>
  );
}

/** Resource class (EAS) or stack (Bitrise). */
function ResourceClassField({ form }: { form: ProfileFormApi }) {
  const bitrise = form.bitriseProfile;
  return (
    <FormField id="profile-resource-class" label={bitrise ? 'Stack' : 'Resource class'}>
      <Input data-testid="profile-resource-class" value={form.values.resourceClass} onChange={(e) => form.patch({ resourceClass: e.target.value })} placeholder={bitrise ? 'osx-xcode-16' : 'medium'} className="font-mono sm:text-[13px]" spellCheck={false} />
    </FormField>
  );
}

function ArtifactField({ form }: { form: ProfileFormApi }) {
  return (
    <FormField id="profile-artifact" label="Artifact">
      <OptionSelect id="profile-artifact" data-testid="profile-artifact" value={form.values.artifactKind} onValueChange={(v) => form.patch({ artifactKind: v as ArtifactKind })} options={ArtifactKind.options.map((k) => ({ value: k, label: k }))} />
    </FormField>
  );
}

/** eas.json profile (Expo / React Native only), resource class / stack and artifact kind: two per row at most, so none is squeezed. */
export function ProfileProviderRow({ form }: { form: ProfileFormApi }) {
  return (
    <div className="grid gap-4 sm:grid-cols-2">
      {form.bitriseProfile ? null : <EasProfileField form={form} />}
      <ResourceClassField form={form} />
      <ArtifactField form={form} />
    </div>
  );
}
